
export class SampleResultColumnFilterDto {
    tempCalculationId: string ;
    sampleId: string ;
    matrixCode: string ;
    ceilOrFloorReached: boolean;
}